/* eslint-disable @typescript-eslint/no-unused-vars */
import isUndefined from 'lodash/isUndefined'
import pick from 'lodash/pick'

import {
  APPLICANT_FORM_TYPE_IDS,
  FormTypeId,
} from '~/common/constants/formTypes'
import { FormProps } from '~/common/types/form'
import configs from '~/form/configs'
import convertToHankaku from '~/form/libs/convertToHankaku'
import namesComposer from '~/form/libs/namesComposer'

const useCreateSendParam = (
  formTypeId: FormTypeId | undefined,
  clientId: string | undefined,
  formName: string | undefined,
  employmentStatus: string | undefined
) => {
  const createSendParam = (values: FormProps) => {
    if (isUndefined(formTypeId)) return undefined

    const config = configs[formTypeId]
    if (isUndefined(config)) return undefined

    const names = namesComposer(formTypeId)

    // 不要な情報を送信しない
    const pickValues = pick(values, names)

    // 半角変換
    if (pickValues.addressHomeNumber) {
      pickValues.addressHomeNumber = convertToHankaku(
        pickValues.addressHomeNumber
      )
    }

    if (pickValues.addressBuildingName) {
      pickValues.addressBuildingName = convertToHankaku(
        pickValues.addressBuildingName
      )
    }

    if (APPLICANT_FORM_TYPE_IDS.includes(formTypeId)) {
      // 応募の場合
      return {
        ...pickValues,
        formType: formTypeId,
        clientId,
        formName,
        // メルマガ購読フラグ
        acceptMailMagazine: values.acceptMailMagazine,
        employmentStatus,
        // 代行フラグ
        requestForRegistration: values.requestForRegistration,
      }
    }

    if (formTypeId === 'REPOST') {
      // 再掲載リクエストの場合
      return {
        ...pickValues,
        // メルマガ購読フラグ
        acceptMailMagazine: values.acceptMailMagazine,
        clientId,
        employmentStatus,
      }
    }

    // 企業登録の場合
    return {
      ...pickValues,
    }
  }

  return createSendParam
}

export default useCreateSendParam
